import React, { useCallback, useContext, useState } from 'react';

// REDUX
import { useDispatch, useSelector } from 'react-redux';

import { ApplicationState } from 'store';

// COMPONENTS
import ButtonImage from 'components/Common/ButtonImage';
import { imprimirDareRequest } from 'store/modules/api/dare/imprimirDare/actions';
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce';
import PDFBlobViewer from 'components/Common/PDFBlobViewer';

export const ImprimirDare: React.FC = () => {
	const dispatch = useDispatch();

	const [imprimirProtocolo, setImprimirProtocolo] = useState<boolean>(false);

	const { gerarDare } = useSelector((state: ApplicationState) => state.api);
	const { atualizarDare } = useSelector(
		(state: ApplicationState) => state.api.dare,
	);
	const { baixarArquivos } = useSelector(
		(state: ApplicationState) => state.api.utils,
	);
	const { token } = useContext<IAuthContext>(AuthContext);

	const handleImprimir = useCallback(() => {
		if (
			atualizarDare.numeroDare ||
			(gerarDare.data && gerarDare.data?.numeroControleGuiaMae)
		) {
			setImprimirProtocolo(true);
			dispatch(
				imprimirDareRequest(token, {
					numeroDare:
						atualizarDare.numeroDare ||
						gerarDare.data?.numeroControleGuiaMae.toString() ||
						'',
				}),
			);
		}
	}, [atualizarDare.numeroDare, dispatch, gerarDare.data, token]);

	const handleOnClose = useCallback(() => {}, []);

	return (
		<>
			<ButtonImage
				type="button"
				src="btn-imprimir-dare"
				onClick={handleImprimir}
			/>
			{(atualizarDare.numeroDare || gerarDare.data?.numeroControleGuiaMae) &&
				baixarArquivos.data.arquivo &&
				baixarArquivos.instanceRequest === 'imprimir_dare' &&
				imprimirProtocolo && (
					<PDFBlobViewer
						title={`Número do documento: ${
							atualizarDare.numeroDare || gerarDare.data?.numeroControleGuiaMae
						}`}
						source={baixarArquivos.data.arquivo}
						onClose={handleOnClose}
					/>
				)}
		</>
	);
};
